// frontend/src/components/wizard/StepReview/MappingSummary.jsx
import React from 'react';
import { Settings2 } from 'lucide-react';
import { useLanguageStore } from '../../../store/useLanguageStore';

export const MappingSummary = ({ mappedFields, ignoredFields, fixedFields, totalRules }) => {
  const { t } = useLanguageStore();
  return (
    <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6">
      <h3 className="font-bold text-slate-800 flex items-center mb-6">
        <Settings2 className="w-5 h-5 mr-2 text-indigo-600" /> {t('wizard.review.mapping_summary.title') || 'Resumen de Mapeo y Reglas'}
      </h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="bg-slate-50 rounded-xl p-4 text-center border border-slate-100">
          <p className="text-3xl font-black text-slate-700">{mappedFields}</p>
          <p className="text-[11px] font-bold text-slate-500 uppercase mt-1">{t('wizard.review.mapping_summary.mapped') || 'Campos Mapeados'}</p>
        </div>
        <div className="bg-amber-50 rounded-xl p-4 text-center border border-amber-100">
          <p className="text-3xl font-black text-amber-600">{ignoredFields}</p>
          <p className="text-[11px] font-bold text-amber-700 uppercase mt-1">{t('wizard.review.mapping_summary.ignored') || 'Ignorados'}</p>
        </div>
        <div className="bg-blue-50 rounded-xl p-4 text-center border border-blue-100">
          <p className="text-3xl font-black text-blue-600">{fixedFields}</p>
          <p className="text-[11px] font-bold text-blue-700 uppercase mt-1">{t('wizard.review.mapping_summary.fixed') || 'Valores Fijos'}</p>
        </div>
        <div className="bg-purple-50 rounded-xl p-4 text-center border border-purple-100">
          <p className="text-3xl font-black text-purple-600">{totalRules}</p>
          <p className="text-[11px] font-bold text-purple-700 uppercase mt-1">{t('wizard.review.mapping_summary.active_rules') || 'Reglas Activas'}</p>
        </div>
      </div>
    </div>
  );
};